/**
 * Lazy frontend Sentry bootstrap. No-ops when VITE_SENTRY_DSN is absent so
 * local dev and the test runner never touch the Sentry CDN. Lazy-requiring
 * `@sentry/react` lets the rest of the app boot when the optional dep isn't
 * installed yet.
 */
let started = false;

export async function initSentry(): Promise<void> {
  if (started) return;
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;
  started = true;

  try {
    const Sentry = await import('@sentry/react');
    Sentry.init({
      dsn,
      environment: import.meta.env.MODE,
      tracesSampleRate: import.meta.env.MODE === 'production' ? 0.1 : 1.0,
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 1.0,
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('[sentry] VITE_SENTRY_DSN set but @sentry/react is not installed; skipping.', err);
  }
}

export async function captureException(err: unknown): Promise<void> {
  if (!started) return;
  try {
    const Sentry = await import('@sentry/react');
    Sentry.captureException(err);
  } catch {
    /* sentry dropped silently */
  }
}
